import { Box, styled } from '@mui/material';

import { generateAircraftData } from '#test';

import { CrewAvailabilityCard } from './AircraftCard';

const PREFIX = 'TSMED-CrewAvailabilityCardPreview';

export const CrewAvailabilityCardPreviewClasses = {
  root: `${PREFIX}-root`,
} as const;

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'inherit',
}));

export const CrewAvailabilityCardPreview = () => {
  const aircraftData = generateAircraftData();

  return (
    <Root>
      <CrewAvailabilityCard
        aircraftData={aircraftData}
        availabilityGroupName="4-8h"
        fullSize={false}
        sx={{
          transform: 'scale(0.72)',
          backgroundColor: 'black',
          fontSize: '10px',
          height: 200,
          width: 230,
        }}
      />
    </Root>
  );
};
